import React from 'react';
import { Box, Typography, Button, Stack, useTheme } from '@mui/material';
import { Add } from '@mui/icons-material';
import AppSearch from '../../components/base/AppSearch';

const WorkshopHeader = ({ count, searchTerm, setSearchTerm, onAddNew }) => {
  const theme = useTheme();

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-between', 
        alignItems: { xs: 'flex-start', md: 'center' }, 
        mb: 5,
        gap: 3
      }}
    >
      {/* SECTION TITRE */}
      <Box>
        <Typography 
          variant="h3" 
          sx={{ 
            color: '#1B254B', 
            fontWeight: '800', 
            fontSize: '34px',
            letterSpacing: '-0.02em',
            mb: 0.5
          }}
        >
          Ateliers
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <Box 
            sx={{ 
              px: 1.5, 
              py: 0.5, 
              bgcolor: '#E9EDF7', 
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography sx={{ color: '#4318FF', fontWeight: '700', fontSize: '14px' }}>
              {count} au total
            </Typography>
          </Box>
          <Typography sx={{ color: '#A3AED0', fontSize: '14px', fontWeight: '500' }}>
            Gestion des sessions de formation
          </Typography>
        </Stack>
      </Box>

      {/* SECTION ACTIONS */}
      <Stack 
        direction="row" 
        spacing={2} 
        sx={{ 
          width: { xs: '100%', md: 'auto' },
          justifyContent: 'flex-end'
        }}
      >
        <Box sx={{ minWidth: { md: '300px' } }}>
          <AppSearch 
            value={searchTerm} 
            onChange={setSearchTerm} 
            placeholder="Rechercher un atelier..."
          />
        </Box>
        
        <Button
          variant="contained"
          startIcon={<Add sx={{ fontSize: '20px !important' }} />}
          onClick={onAddNew}
          sx={{ 
            bgcolor: '#4318FF', 
            color: '#fff',
            borderRadius: '16px', 
            textTransform: 'none', 
            fontWeight: '700',
            px: 3,
            py: 1.5,
            fontSize: '15px',
            boxShadow: '0px 10px 20px rgba(67, 24, 255, 0.2)',
            transition: '0.3s ease',
            '&:hover': { 
              bgcolor: '#3311CC',
              boxShadow: '0px 12px 25px rgba(67, 24, 255, 0.3)',
              transform: 'translateY(-2px)'
            },
            '&:active': {
              transform: 'translateY(0)'
            }
          }}
        >
          Créer un atelier
        </Button>
      </Stack>
    </Box>
  );
};

export default WorkshopHeader;
